import json from './languages.json';
import i18next from '../../i18n';

class Translation {
  constructor() {
    this.language = {
      "name": "en",
      "displayName": "English",
      "dir": "ltr"
    }
    this.measurementSystem = 'imperial';
  }

  supportedLanguages() {
    return json.languages;
  }

  getLanguage(name) {
    return json.languages.find(lang => lang.name === name);
  }

  getCurrentLanguage() {
    return this.language;
  }

  async setLanguage(name) {
    this.language = json.languages.find(lang => lang.name === name);
    document.body.setAttribute('dir', this.language.dir)
    await i18next.changeLanguage(name);
  }

  getMeasurementSystem() {
    return this.measurementSystem;
  }

}
export default new Translation();
